import React from "react";
import { useLanguage } from "./LanguageProvider"; // LanguageProviderからuseLanguageをインポート

const CommissionTOS = () => {
  const { translate } = useLanguage(); // useLanguageフックでtranslateを取得

  return (
    <div id="commission-tos">
      {/* 依頼セクション */}
      <section className="tos-section">
        <h3>{translate("commission")}</h3> {/* 翻訳されたテキストを表示 */}
        <ol>
          <li>
            {translate("estimate_info_1")}
            <br />
            <small>{translate("estimate_info_2")}</small>
          </li>
          <li>{translate("estimate_info_3")}</li>
          <li>
            {translate("estimate_info_4")}
            <br />
            <small>{translate("estimate_info_5")}</small>
          </li>
        </ol>
      </section>

      {/* 制作開始セクション */}
      <section className="tos-section">
        <h3>{translate("production_start")}</h3>
        {/* 翻訳されたテキストを表示 */}
        <ol>
          <li>
            {translate("rough_creation")}
            <br />
            {translate("confirm_rough")}
          </li>
          <li>
            {translate("deliver_final")}
            <br />
            <small>{translate("receive_method")}</small>
          </li>
        </ol>
      </section>

      {/* お支払いについてセクション */}
      <section className="tos-section">
        <h3>{translate("payment")}</h3> {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("prepayment")}</li>
          <li>{translate("no_refund")}</li>
          <li>{translate("paypal_only")}</li>
        </ul>
      </section>

      {/* NG内容セクション */}
      <section className="tos-section">
        <h3>{translate("ng_content")}</h3> {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("trace_copy")}</li>
          <li>{translate("sexual_expression")}</li>
          <li>{translate("secondary_creation")}</li>
          <li>{translate("extreme_expression")}</li>
          <li>{translate("politics_religion")}</li>
          <li>{translate("live_action")}</li>
        </ul>
      </section>

      {/* 作品についてセクション */}
      <section className="tos-section">
        <h3>{translate("about_work")}</h3> {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("copyright_policy")}</li>
          <li>{translate("ai_restriction")}</li>
          <li>{translate("commercial_use")}</li>
          <li>{translate("modification_policy")}</li>
          <li>{translate("responsibility_policy")}</li>
        </ul>
      </section>

      {/* 使用権利についてセクション */}
      <section className="tos-section">
        <h3>{translate("usage_rights")}</h3> {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("social_media")}</li>
          <li>{translate("advertisement")}</li>
        </ul>
      </section>

      {/* リテイクポリシーセクション */}
      <section className="tos-section">
        <h3>{translate("retake_policy")}</h3> {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("rough_fix_limit")}</li>
          <li>{translate("additional_fix_fee")}</li>
          <li>{translate("post_delivery_fix")}</li>
        </ul>
      </section>

      {/* 制作期間についてセクション */}
      <section className="tos-section">
        <h3>{translate("production_period")}</h3>{" "}
        {/* 翻訳されたテキストを表示 */}
        <ul>
          <li>{translate("standard_period")}</li>
          <li>{translate("response_time")}</li>
        </ul>
      </section>
    </div>
  );
};

export default CommissionTOS;
